import { render } from "./copy-right.vue?vue&type=template&id=14b23dc7&scoped=true"
import script from "./copy-right.vue?vue&type=script&lang=js"
export * from "./copy-right.vue?vue&type=script&lang=js"

import "./copy-right.vue?vue&type=style&index=0&id=14b23dc7&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Desktop/ubang-deploy-work/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b23dc7"]])

export default __exports__